import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Field, getFormValues, reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';

import { renderFieldRadio } from '../Form/renderField';
import { v_required } from '../Form/checkField';

import { onSubmitFail } from '../../utils/commonFormsHandlers';

const NORMALIZE_ADDRESS_FORM = 'normalize_address_form';

class NormalizeAddressForm extends Component {
	render() {
		const { handleSubmit, t, addresses, validity } = this.props;

    const options = addresses.map((a, i) => {
      return {
        value: i.toString(),
        label: <div>
          <div>{a.indirizzo}, {a.civico}</div>
          <div>{a.frazione ? a.frazione + ', ': ''}{a.comune}, {a.provincia} {a.cap}</div>
        </div>
      };
    });

		return <Fragment>
      {
        validity === 1 && <Fragment>
          <div className='row'>
            <div className='col'>
              <p>{t('form.step3.normalize.wrong.address_changed')}</p>
            </div>
          </div>
          <div className='row'>
            <div className='form-group col mb-3'>
              {
                addresses.map(a => {
                  return <div className='form-group-check p-0'>
                    <div className='form-check p-0'>
                      <label className='form-check-label no-icon'>
                        <div>
                          {a.indirizzo}, {a.civico}, {a.frazione ? a.frazione + ', ' : ''}{a.comune}, {a.provincia} {a.cap}
                        </div>
                      </label>
                    </div>
                  </div>;
                })
              }
            </div>
          </div>
          <div className='row'>
            <div className='col'>
              <p>{t('form.step3.normalize.wrong.info')}</p>
            </div>
          </div>
        </Fragment>
      }
			{
        validity === 3 &&  <form onSubmit={handleSubmit} noValidate>
          <div className='row'>
            <div className='col'>
              <p className='mb-0'>{t('form.step3.normalize.multiple.address_choose')}</p>
            </div>
          </div>
  				<div className='row'>
  					<div className='form-group col-md-12'>
  						<Field
                name='n_address'
                label={null}
                options={options}
                component={renderFieldRadio}
                separator={true}
                className='flex-column'
                optionsContainerClassName='space-bottom'
                labelOptionClassName='space-bottom'
                required={true}
                validate={[(value) => v_required(value, t)]}
              />
  					</div>
  				</div>
          <div className='row'>
            <div className='col'>
              <p className='mx-4'>{t('form.step3.normalize.multiple.info')}</p>
            </div>
          </div>
  			</form>
      }
      {
        validity === 2 && <div className='row'>
          <div className='col'>
            <p>{t('form.step3.normalize.error.text')}</p>
          </div>
        </div>
      }
		</Fragment>;
	}
}

const defaultValues = {
	n_address: '0'
};

const mapStateToProps = (state) => {
	return {
		initialValues: defaultValues,
		formValues: getFormValues(NORMALIZE_ADDRESS_FORM)(state)
	};
};

const mapDispatchToProps = {};

NormalizeAddressForm.propTypes = {
	initialValues: PropTypes.object,
	formValues: PropTypes.object,
	handleSubmit: PropTypes.func,

	addresses: PropTypes.array,
  validity: PropTypes.number,

	t: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
	form: NORMALIZE_ADDRESS_FORM, // a unique name for this form
	destroyOnUnmount: false,
	onSubmitFail: (errors) => {
		onSubmitFail(errors);
	},
})(NormalizeAddressForm));
